module.exports = __webpack_public_path__ + "static/gads-shoes-00ed64847cf8a5e58d43cb24074756b6.png";